import { patchClient } from "./patchClient";
import {
  fileServiceCreateFile,
  fileServiceDeleteFile,
  fileServiceGetFile,
  fileServiceListFiles,
  fileServiceMoveFile,
  fileServiceRenameFile,
  type deputy_v1_file_CreateFileRequest,
  type deputy_v1_file_File,
  fileServiceFileLockOperator,
  fileServiceFileChangeAiAccess,
  fileServiceCreateFileShare,
  fileServiceDeleteFileShare,
  fileServiceGetFileByFileShare,
  fileServiceGetFileShare,
  fileServiceListFileCommentByFileShare,
  fileServiceUpdateFileShare,
  fileServiceSetSystemFile,
  fileServiceBatchCheckFilePermissions,
  type deputy_v1_file_FilePermission,
  fileServiceConvertDocxToPdf,
  fileServiceSaveBlobFile,
  type deputy_v1_file_SaveBlobFileRequest,
  type deputy_v1_file_SaveBlobFileResponse,
} from "@deputy-ai/data-platform-api/v1/file";

export type FilePermission = deputy_v1_file_FilePermission;

export type DPFile = deputy_v1_file_File & {
  permissions?: FilePermission;
};

export const FILE_UPLOAD_URL = "/api/v1/file/upload";

export type CreateFileRequest = deputy_v1_file_CreateFileRequest;
export const createFile = patchClient(fileServiceCreateFile);

export const deleteFile = patchClient(fileServiceDeleteFile);

export const getFile = patchClient(fileServiceGetFile);

export const listFiles = patchClient(fileServiceListFiles);

export const moveFile = patchClient(fileServiceMoveFile);

export const renameFile = patchClient(fileServiceRenameFile);

export const moveFileApi = patchClient(fileServiceMoveFile);

export const fileLockOperatorApi = patchClient(fileServiceFileLockOperator);

export const fileChangeAiAccessApi = patchClient(fileServiceFileChangeAiAccess);

export const createFileShare = patchClient(fileServiceCreateFileShare);
export const updateFileShare = patchClient(fileServiceUpdateFileShare);
export const getFileShare = patchClient(fileServiceGetFileShare);
export const deleteFileShare = patchClient(fileServiceDeleteFileShare);
export const getFileByFileShare = patchClient(fileServiceGetFileByFileShare);
export const listFileCommentByFileShare = patchClient(
  fileServiceListFileCommentByFileShare
);
export const setSystemFileApi = patchClient(fileServiceSetSystemFile);
export const batchCheckFilePermissionsApi = patchClient(
  fileServiceBatchCheckFilePermissions
);

export const convertDocxToPdfApi = patchClient(fileServiceConvertDocxToPdf);

// SaveBlobFile API types and function
export type SaveBlobFileRequest = deputy_v1_file_SaveBlobFileRequest;
export type SaveBlobFileResponse = deputy_v1_file_SaveBlobFileResponse;
export const saveBlobFileApi = patchClient(fileServiceSaveBlobFile);
